module.exports = __webpack_public_path__ + "img/password.2549a964.svg";